import { SocketMatchmakingSend } from '../socket/SocketMatchmakingSend.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../analytics/Analytics.ts';
import { createDivIn, createSpanIn } from '../ui_utils/DomUtils.ts';
export class UIVLIController {
    // eslint-disable-next-line class-methods-use-this
    userSkippedAd() {
        // eslint-disable-next-line no-console
        console.log(`[Preroll] Ad Hidden/Skipped`);
        UIVLIController.sendAdsPerformanceData(AnalyticEventType.VideoAdsComplete);
    }
    static sendMatchmakingRequestAfterAd() {
        if (!SocketMatchmakingSend.lastMatchmakingRequest) return;
        const shouldDelay = false;
        SocketMatchmakingSend.enterMatchmaker(SocketMatchmakingSend.lastMatchmakingRequest, shouldDelay);
    }
    // eslint-disable-next-line class-methods-use-this
    userFinishedWatching() {
        // eslint-disable-next-line no-console
        console.log(`[Preroll] User completed watching ad`);
        UIVLIController.sendMatchmakingRequestAfterAd();
    }
    adFailedToStart() {
        // eslint-disable-next-line no-console
        console.log('[Preroll] Ad error occurred. Sending to matchmaking now');
        this.sendToMatchmakingBecauseAdFailed();
    }
    adIsReadyToBeShown() {
        // eslint-disable-next-line no-console
        console.log('[Preroll] Ad started');
        this.removeLoadingAdBackground();
        clearTimeout(this.instreamAdStartTimeout);
        this.instreamAdStartTimeout = undefined;
    }
    startMatchmakingVideoAd() {
        var _window_viAPItag;
        UIVLIController.sendAdsPerformanceData(AnalyticEventType.VideoAdsCalled);
        if (((_window_viAPItag = window.viAPItag) === null || _window_viAPItag === void 0 ? void 0 : _window_viAPItag.initPowerInstream) !== undefined) {
            this.startInstreamAd(window.viAPItag.initPowerInstream);
        } else {
            // Fallback if nothing works
            UIVLIController.sendMatchmakingRequestAfterAd();
            UIVLIController.sendAdsPerformanceData(AnalyticEventType.VideoAdsBlocked);
        }
    }
    startInstreamAd(initPowerInstream) {
        this.loadingAdBackground = UIVLIController.buildLoadingAdBackground(document.body);
        this.instreamAdStartTimeout = setTimeout(()=>{
            // eslint-disable-next-line no-console
            console.log('[Preroll] Ad timeout occurred. Sending to matchmaking now');
            this.sendToMatchmakingBecauseAdFailed();
        }, this.INSTREAM_AD_START_TIMEOUT);
        initPowerInstream(UIUtilsEjsVariables.vliPrerollId);
    }
    sendToMatchmakingBecauseAdFailed() {
        clearTimeout(this.INSTREAM_AD_START_TIMEOUT);
        this.instreamAdStartTimeout = undefined;
        this.removeLoadingAdBackground();
        UIVLIController.removeVLIPrerollBecauseAdFailed();
        UIVLIController.sendMatchmakingRequestAfterAd();
        UIVLIController.sendAdsPerformanceData(AnalyticEventType.VideoAdsNeverLoaded);
    }
    static sendAdsPerformanceData(adsAnalyticEventType) {
        const eventData = {
            type: adsAnalyticEventType,
            category: AnalyticEventCategory.AdsPerformance
        };
        void CA.sendAnalyticEvent(eventData);
    }
    static buildLoadingAdBackground(parentContainer) {
        const overlay = createDivIn(parentContainer, 'game-reconnecting-overlay');
        createDivIn(overlay, 'loading-spinner');
        createSpanIn(overlay, 'game-reconnecting-text', {
            key: 'strings:roomPage.loadingAd'
        });
        return overlay;
    }
    removeLoadingAdBackground() {
        var _this_loadingAdBackground;
        (_this_loadingAdBackground = this.loadingAdBackground) === null || _this_loadingAdBackground === void 0 ? void 0 : _this_loadingAdBackground.remove();
    }
    static removeVLIPrerollBecauseAdFailed() {
        const vliPreroll = document.querySelector(`[data-ad-slot="${UIUtilsEjsVariables.vliPrerollId}"]`);
        vliPreroll === null || vliPreroll === void 0 ? void 0 : vliPreroll.remove();
    }
    constructor(){
        this.INSTREAM_AD_START_TIMEOUT = 7500;
        if (window.vitag == undefined) return;
        window.vitag.instreamConfig = {
            loadingText: 'Loading advertisement..',
            hidden: ()=>this.userSkippedAd(),
            complete: ()=>this.userFinishedWatching(),
            error: ()=>this.adFailedToStart(),
            started: ()=>this.adIsReadyToBeShown()
        };
    }
}
